! function() {
    var e, t = {
            1092: function(e, t, i) {
                "use strict";
                i.d(t, {
                    M: function() {
                        return s
                    }
                });
                var n = i(6072),
                    r = i(1717);
                document.addEventListener("DOMContentLoaded", (function() {
                    document.querySelectorAll(".icon").forEach((e => {
                        e.classList.add("loaded")
                    })), document.querySelectorAll('a[target="_blank"]').forEach((e => {
                        e.innerHTML = e.innerHTML + '<span class="visually-hidden"> ' + accessibilityNoticeNewTab + "</span>"
                    })), (0, r.f)()
                })), void 0 !== window.BOOMR && console.log("Built with " + window.BOOMR.themeName + " (https://themes.shopify.com/themes/align/) version " + window.BOOMR.themeVersion + " by Company XYZ (https://companyxyz.io/)."), void 0 === window.Shopify && (window.Shopify = {}), Shopify.bind = function(e, t) {
                    return function() {
                        return e.apply(t, arguments)
                    }
                }, Shopify.setSelectorByValue = function(e, t) {
                    for (var i = 0, n = e.options.length; i < n; i++) {
                        var r = e.options[i];
                        if (t == r.value || t == r.innerHTML) return e.selectedIndex = i, i
                    }
                }, Shopify.addListener = function(e, t, i) {
                    e.addEventListener ? e.addEventListener(t, i, !1) : e.attachEvent("on" + t, i)
                }, Shopify.postLink = function(e, t) {
                    var i = (t = t || {}).method || "post",
                        n = t.parameters || {},
                        r = document.createElement("form");
                    for (var s in r.setAttribute("method", i), r.setAttribute("action", e), n) {
                        var o = document.createElement("input");
                        o.setAttribute("type", "hidden"), o.setAttribute("name", s), o.setAttribute("value", n[s]), r.appendChild(o)
                    }
                    document.body.appendChild(r), r.submit(), document.body.removeChild(r)
                }, Shopify.CountryProvinceSelector = function(e, t, i) {
                    this.countryEl = document.getElementById(e), this.provinceEl = document.getElementById(t), this.provinceContainer = document.getElementById(i.hideElement || t), Shopify.addListener(this.countryEl, "change", Shopify.bind(this.countryHandler, this)), this.initCountry(), this.initProvince()
                }, Shopify.CountryProvinceSelector.prototype = {
                    initCountry: function() {
                        var e = this.countryEl.getAttribute("data-default");
                        Shopify.setSelectorByValue(this.countryEl, e), this.countryHandler()
                    },
                    initProvince: function() {
                        var e = this.provinceEl.getAttribute("data-default");
                        e && this.provinceEl.options.length > 0 && Shopify.setSelectorByValue(this.provinceEl, e)
                    },
                    countryHandler: function(e) {
                        var t = (r = this.countryEl.options[this.countryEl.selectedIndex]).getAttribute("data-provinces"),
                            i = JSON.parse(t);
                        if (this.clearOptions(this.provinceEl), i && 0 == i.length) this.provinceContainer.style.display = "none";
                        else {
                            for (var n = 0; n < i.length; n++) {
                                var r;
                                (r = document.createElement("option")).value = i[n][0], r.innerHTML = i[n][1], this.provinceEl.appendChild(r)
                            }
                            this.provinceContainer.style.display = ""
                        }
                    },
                    clearOptions: function(e) {
                        for (; e.firstChild;) e.removeChild(e.firstChild)
                    },
                    setOptions: function(e, t) {
                        var i = 0;
                        for (t.length; i < t.length; i++) {
                            var n = document.createElement("option");
                            n.value = t[i], n.innerHTML = t[i], e.appendChild(n)
                        }
                    }
                }, document.querySelectorAll("video").forEach((e => {
                    e.muted = !0, new IntersectionObserver((t => {
                        t.forEach((t => {
                            t.isIntersecting ? 1 == e.autoplay && e.paused && e.play().catch((e => {
                                "AbortError" !== e.name && console.error("Error playing video:", e)
                            })) : e.pause()
                        }))
                    }), {
                        threshold: 0
                    }).observe(e)
                })), document.querySelectorAll("video.hover-play").forEach((e => {
                    const t = e.closest(".card");
                    e.pause(), t ? (t.addEventListener("mouseenter", (() => {
                        e.play().catch((e => {
                            "AbortError" !== e.name && console.error("Error playing video:", e)
                        }))
                    })), t.addEventListener("mouseleave", (() => {
                        e.pause()
                    }))) : (e.addEventListener("mouseenter", (() => {
                        e.play().catch((e => {
                            "AbortError" !== e.name && console.error("Error playing video:", e)
                        }))
                    })), e.addEventListener("mouseleave", (() => {
                        e.pause()
                    })))
                }));
                const s = function() {
                    [].slice.call(document.querySelectorAll("video")).forEach((e => {
                        const t = e.parentElement.querySelector(".figure--video__poster");
                        t && t.addEventListener("click", (() => {
                            t.classList.add("hidden"), e.play()
                        }))
                    }));
                    var e = [].slice.call(document.querySelectorAll(".figure--video-external"));
                    if ("IntersectionObserver" in window) {
                        var t = new IntersectionObserver((function(e, t) {
                            e.forEach((function(e) {
                                if (e.isIntersecting) "vimeo" == e.target.dataset.type && fetch("http://vimeo.com/api/v2/video/" + e.target.dataset.id + ".json").then((e => {
                                    if (!e.ok) throw new Error(`HTTP error ${e.status}`);
                                    return e.json()
                                })).then((t => {
                                    e.target.querySelector(".figure--video__external-poster-image").src = t[0].thumbnail_large
                                })), e.target.addEventListener("click", (function() {
                                    if (!e.target.querySelector("iframe")) {
                                        let e = this.dataset.type,
                                            t = document.createElement("iframe");
                                        t.setAttribute("frameborder", "0"), t.setAttribute("allowfullscreen", ""), t.setAttribute("allow", "autoplay"), "youtube" == e ? (t.setAttribute("id", "youtube"), t.setAttribute("src", "https://www.youtube.com/embed/" + this.dataset.id + this.dataset.videotags + "rel=0&showinfo=0&autoplay=1")) : t.setAttribute("src", "https://player.vimeo.com/video/" + this.dataset.id + this.dataset.videotags + "rel=0&showinfo=0&autoplay=1"), this.appendChild(t), setTimeout((() => {
                                            this.querySelector(".figure--video__poster").classList.add("hidden")
                                        }), 350)
                                    }
                                }));
                                else if (e.target.querySelector("iframe")) {
                                    let i = e.target.dataset.type,
                                        n = e.target.querySelectorAll("iframe");
                                    if ("youtube" == i) {
                                        var t = {
                                            event: "command",
                                            func: "pauseVideo"
                                        };
                                        n[0].contentWindow.postMessage(JSON.stringify(t), "*")
                                    } else "vimeo" == i && (t = {
                                        method: "pause",
                                        value: "true"
                                    }, n[0].contentWindow.postMessage(JSON.stringify(t), "*"))
                                }
                            }))
                        }));
                        e.forEach((function(e) {
                            t.observe(e)
                        }))
                    }
                };
                s(), window.addEventListener("beforeprint", (() => {
                    const e = document.body.querySelectorAll("details"),
                        t = document.body.querySelectorAll("img");
                    for (let t = 0; t < e.length; t++) e[t].open ? e[t].dataset.open = "1" : e[t].setAttribute("open", "");
                    for (let e = 0; e < t.length; e++) t[e].dataset.open = "1"
                })), window.addEventListener("afterprint", (() => {
                    const e = document.body.querySelectorAll("details");
                    for (let t = 0; t < e.length; t++) e[t].dataset.open ? e[t].dataset.open = "" : e[t].removeAttribute("open")
                })), Shopify.designMode && document.addEventListener("shopify:section:load", (() => {
                    s(), document.querySelectorAll(".icon").forEach((e => {
                        e.classList.add("loaded")
                    }))
                }));
                class o extends HTMLElement {
                    constructor() {
                        super(), this.addEventListener("change", (e => {
                            const t = new CustomEvent("variant-update", {
                                detail: {
                                    event: e,
                                    section: this.dataset.section,
                                    product: this.dataset.product,
                                    block: this.dataset.block
                                },
                                bubbles: !0
                            });
                            this.dispatchEvent(t)
                        })), document.addEventListener("variant-update", (e => {
                            this.dataset.section === e.detail.section && this.dataset.product === e.detail.product && this.dataset.block === e.detail.block && (e.detail.event.target.closest("variant-selects") !== this && this.syncSelection(e.detail.event.target), this.onVariantChange())
                        })), this.isCardBasedProductForm = null !== this.closest(".card__content")
                    }
                    connectedCallback() {
                        this.mainProductUniqueIdentifier = "main-product-" + this.dataset.product, this.uniqueIdentifier = this.dataset.section + "-" + this.dataset.product + (this.dataset.block ? "-" + this.dataset.block : "")
                    }
                    onVariantChange() {
                        this.updateOptions(), this.updateMasterId(), this.currentVariant ? (this.updateVariantStatuses(), this.updateImageSwatches(), this.updateMedia(), this.updateURL(), this.updateLinks(), this.renderProductInfo(), this.updateVariantInput(), this.updateAddToCart()) : void 0 === this.currentVariant && this.setUnavailable()
                    }
                    syncSelection(e) {
                        const {
                            name: t,
                            value: i
                        } = e, n = this.querySelector(`[name="${t}"]`), r = null == n ? void 0 : n.tagName;
                        n && ("SELECT" === r ? this.querySelector(`[name="${t}"] [value="${i}"]`).selected = !0 : this.querySelector(`[name="${t}"][value="${i}"]`).checked = !0)
                    }
                    updateOptions() {
                        this.options = Array.from(this.querySelectorAll("select, fieldset"), (e => {
                            return "SELECT" === e.tagName ? e.value : "FIELDSET" === e.tagName ? null === (t = Array.from(e.querySelectorAll("input")).find((e => e.checked))) || void 0 === t ? void 0 : t.value : void 0;
                            var t
                        }))
                    }
                    updateMasterId() {
                        this.options.includes(void 0) ? this.currentVariant = null : this.currentVariant = this.getVariantData().find((e => !e.options.map(((e, t) => this.options[t] === e)).includes(!1)))
                    }
                    updateVariantStatuses() {
                        const e = this.querySelector(":checked").value,
                            t = this.getVariantData().filter((t => t.options[0] === e));
                        this.getProductVariantSelects().forEach((e => {
                            const i = e.querySelectorAll("select, fieldset");
                            i.forEach(((e, n) => {
                                if (0 === n) return;
                                const r = e.querySelectorAll('input[type="radio"], option'),
                                    s = i[n - 1].querySelector(":checked").value,
                                    o = t.filter((e => e.available && e[`option${n}`] === s)).map((e => e[`option${n+1}`]));
                                this.setInputAvailability(r, o)
                            }))
                        }))
                    }
                    setInputAvailability(e, t) {
                        e.forEach((e => {
                            const i = e.getAttribute("value"),
                                n = t.includes(i);
                            "OPTION" === e.tagName && (e.innerText = n ? i : window.productStrings.unavailable_with_option.replace("[value]", i))
                        }))
                    }
                    updateImageSwatches() {
                        this.querySelectorAll("fieldset:has(.image-swatch)").forEach((e => {
                            const t = e.dataset.optionPosition,
                                i = e.querySelectorAll(".image-swatch");
                            for (const e of i) {
                                const i = [...this.options];
                                i[t - 1] = e.value;
                                const n = this.getVariantData().find((e => e.options[0] == i[0] && e.options[1] == i[1] && e.options[2] == i[2]));
                                if (!n) continue;
                                const r = e.labels[0],
                                    s = r.querySelectorAll("img.variant-image"),
                                    o = r.querySelector(`img[data-variant-id="${n.id}"]`),
                                    a = r.querySelector(".image_swatch--text_value");
                                s.forEach((e => {
                                    e.classList.add("hidden")
                                })), a.classList.add("u-hide"), o ? o.classList.remove("hidden") : a.classList.remove("u-hide")
                            }
                        }))
                    }
                    updateMedia() {
                        if (!this.currentVariant) return;
                        if (!this.currentVariant.featured_media) return;
                        const e = document.querySelector(`#gallery-${this.uniqueIdentifier}`),
                            t = e.dataset.variantStyle;
                        if (this.currentVariant.featured_media) {
                            const r = this.currentVariant.featured_media.id;
                            if ("default" == t)
                                if (e.swiper.initialized) {
                                    var i, n;
                                    const t = null !== (i = e.swiper.virtual) && void 0 !== i && null !== (n = i.slides) && void 0 !== n && n.length ? e.swiper.virtual.slides : e.swiper.slides,
                                        s = Array.from(t).findIndex((e => e.dataset.id == r)); - 1 !== s && e.swiper.slideToLoop(s)
                                } else {
                                    const t = e.querySelector(`[data-id="${r}"]`);
                                    t && e.prepend(t)
                                }
                            else if ("variant" == t) {
                                const t = e.querySelector(`[data-id="${r}"]`);
                                t && (e.firstChild.classList.add("u-hide"), t.classList.remove("u-hide"), e.prepend(t))
                            }
                            const s = document.querySelector(`#sticky-gallery-${this.uniqueIdentifier}`);
                            if (s) {
                                const e = s.querySelectorAll(".sticky-add-to-cart__image"),
                                    t = this.currentVariant.id;
                                e.forEach((e => {
                                    e.dataset.variantId == t ? e.classList.remove("u-hide") : e.classList.add("u-hide")
                                }))
                            }
                        }
                    }
                    updateURL() {
                        if ("false" === this.dataset.updateUrl) return;
                        const e = `${this.dataset.url}?variant=${this.currentVariant.id}`;
                        window.history.replaceState({}, "", e)
                    }
                    updateLinks() {
                        if (!this.isCardBasedProductForm) return;
                        const e = this.closest(".card__content").querySelector(".button--view-product");
                        "A" === (null == e ? void 0 : e.tagName) && (e.href = this.dataset.url.split("?")[0] + `?variant=${this.currentVariant.id}`)
                    }
                    updateVariantInput() {
                        document.querySelectorAll(`#form-product-${this.uniqueIdentifier}, #form-product-installment-${this.uniqueIdentifier}`).forEach((e => {
                            const t = e.querySelector('input[name="id"]');
                            t.value = this.currentVariant.id, t.dispatchEvent(new Event("change", {
                                bubbles: !0
                            }))
                        }))
                    }
                    renderProductInfo() {
                        var e;
                        const t = document.getElementById(`price-${this.uniqueIdentifier}`);
                        t && (t.classList.contains("price--on-sale") ? t.querySelectorAll(".price__sale .price-item").forEach((e => e.classList.add("skeleton-loading"))) : t.querySelector(".price__regular").classList.add("skeleton-loading"));
                        const i = document.getElementById(`sticky-price-${this.uniqueIdentifier}`);
                        i && (i.classList.contains("price--on-sale") ? i.querySelectorAll(".price__sale .price-item").forEach((e => e.classList.add("skeleton-loading"))) : i.querySelector(".price__regular").classList.add("skeleton-loading"));
                        const r = document.getElementById(`pickup-availability-${this.uniqueIdentifier}`);
                        null == r || null === (e = r.querySelector(".skeleton-loading-wrapper")) || void 0 === e || e.classList.add("skeleton-loading");
                        const s = document.getElementById(`stock-status-${this.uniqueIdentifier}`);
                        null == s || s.classList.add("skeleton-loading");
                        const o = document.getElementById(`pickup-availability-modal-${this.uniqueIdentifier}`);
                        fetch(`${this.dataset.url}?variant=${this.currentVariant.id}`).then((e => e.text())).then((e => {
                            const a = (new DOMParser).parseFromString(e, "text/html"),
                                c = a.getElementById(`price-${this.mainProductUniqueIdentifier}`);
                            if (s) {
                                const e = a.getElementById(`stock-status-${this.mainProductUniqueIdentifier}`);
                                e ? (s.classList.remove("u-invisible"), s.innerHTML = e.innerHTML, s.classList = e.classList) : null == s || s.classList.add("u-invisible")
                            }
                            if (c && t ? (t.classList.remove("u-invisible"), t.innerHTML = c.innerHTML, t.classList = c.classList) : null == t || t.classList.add("u-invisible"), i) {
                                const e = a.getElementById(`sticky-price-${this.mainProductUniqueIdentifier}`);
                                e ? (i.classList.remove("u-invisible"), i.innerHTML = e.innerHTML, i.classList = e.classList) : null == i || i.classList.add("u-invisible")
                            }
                            if (r) {
                                const e = a.getElementById(`pickup-availability-${this.mainProductUniqueIdentifier}`);
                                e && (r.innerHTML = e.innerHTML, r.classList = e.classList)
                            }
                            if (o) {
                                const e = a.getElementById(`pickup-availability-modal-${this.mainProductUniqueIdentifier}`);
                                e && (o.innerHTML = e.innerHTML)
                            }
                            const l = document.querySelector(".pickup-availability"),
                                d = document.getElementById("overlay"),
                                u = document.getElementById("pickup-availability-open"),
                                h = document.getElementById("pickup-availability-close");
                            u && document.getElementById("pickup-availability-open").addEventListener("click", (function() {
                                l.classList.add("open"), d.classList.add("open"), document.body.classList.add("active", "minicart"), (0, n.hO)(!0)
                            })), h && document.getElementById("pickup-availability-close").addEventListener("click", (function() {
                                l.classList.remove("open"), document.body.classList.remove("active", "minicart"), (0, n.hO)(!1), overlay.classList.remove("open", "overlay--all"), (0, n.zx)(l)
                            }))
                        }))
                    }
                    updateAddToCart() {
                        const e = document.querySelectorAll(`.form-product-${this.uniqueIdentifier}`);
                        e && (this.currentVariant.available ? e.forEach((e => {
                            const t = e.querySelector('[name="add"]'),
                                i = e.querySelector('[name="add"] > span:not(.cart-icon)');
                            t && (t.removeAttribute("disabled"), i.textContent = `${cartStrings.addToCart}`)
                        })) : e.forEach((e => {
                            const t = e.querySelector('[name="add"]'),
                                i = e.querySelector('[name="add"] > span:not(.cart-icon)');
                            t && (t.setAttribute("disabled", "disabled"), i.textContent = `${cartStrings.soldOut}`)
                        })))
                    }
                    setUnavailable() {
                        const e = document.querySelectorAll(`.form-product-${this.uniqueIdentifier}`),
                            t = document.getElementById(`stock-status-${this.uniqueIdentifier}`);
                        e.forEach((e => {
                            const i = e.querySelector('[name="add"]'),
                                n = e.querySelector('[name="add"] > span:not(.cart-icon)');
                            i && (n.textContent = `${cartStrings.unavailable}`, i.setAttribute("disabled", "disabled"), t && (t.dataset.state = "unavailable"))
                        }));
                        const i = document.getElementById(`price-${this.uniqueIdentifier}`),
                            n = document.getElementById(`sticky-price-${this.uniqueIdentifier}`);
                        i && this.setPriceUnavailable(i), n && this.setPriceUnavailable(n)
                    }
                    setPriceUnavailable(e) {
                        e.classList.remove("price--on-sale"), e.classList.add("price--sold-out"), e.querySelector(".price__regular .price-item.price-item--regular").textContent = window.productStrings.price_unavailable
                    }
                    getVariantData() {
                        return this.variantData = this.variantData || JSON.parse(this.querySelector('[type="application/json"]').textContent), this.variantData
                    }
                    getProductVariantSelects() {
                        return document.querySelectorAll(`variant-selects[data-section="${this.dataset.section}"][data-product="${this.dataset.product}"][data-block="${this.dataset.block}"]`)
                    }
                }
                customElements.get("variant-selects") || customElements.define("variant-selects", o);
                class a {
                    constructor(e) {
                        this.el = e, this.summary = e.querySelector("summary"), this.content = e.querySelector(".content"), this.animation = null, this.isClosing = !1, this.isExpanding = !1, this.summary.addEventListener("click", (e => this.onClick(e)))
                    }
                    onClick(e) {
                        e.preventDefault(), this.el.style.overflow = "hidden", this.isClosing || !this.el.open ? this.open() : (this.isExpanding || this.el.open) && this.shrink()
                    }
                    shrink() {
                        this.isClosing = !0;
                        const e = `${this.el.offsetHeight}px`,
                            t = `${this.summary.offsetHeight}px`;
                        this.animation && this.animation.cancel(), this.animation = this.el.animate({
                            height: [e, t]
                        }, {
                            duration: 400,
                            easing: "ease-out"
                        }), this.animation.onfinish = () => this.onAnimationFinish(!1), this.animation.oncancel = () => this.isClosing = !1
                    }
                    open() {
                        this.el.style.height = `${this.el.offsetHeight}px`, this.el.open = !0, window.requestAnimationFrame((() => this.expand()))
                    }
                    expand() {
                        this.isExpanding = !0;
                        const e = `${this.el.offsetHeight}px`,
                            t = `${this.summary.offsetHeight+this.content.offsetHeight}px`;
                        this.animation && this.animation.cancel(), this.animation = this.el.animate({
                            height: [e, t]
                        }, {
                            duration: 400,
                            easing: "ease-out"
                        }), this.animation.onfinish = () => this.onAnimationFinish(!0), this.animation.oncancel = () => this.isExpanding = !1
                    }
                    onAnimationFinish(e) {
                        this.el.open = e, this.animation = null, this.isClosing = !1, this.isExpanding = !1, this.el.style.height = this.el.style.overflow = ""
                    }
                }
                document.querySelectorAll("details.accordion__wrapper").forEach((e => {
                    new a(e)
                }))
            },
            157: function(e, t, i) {
                "use strict";
                var n = i(6072),
                    r = i(1717),
                    s = i(1434),
                    o = (i(4056), i(3643)),
                    a = i(1092);
                const c = new s.Z,
                    l = () => {
                        const e = document.querySelectorAll("#ProductGridContainer .card").length;
                        e < 6 && document.querySelectorAll(".banner--large").forEach((e => e.style.display = "none")), e < 13 && document.querySelectorAll(".banner--small").forEach((e => e.style.display = "none"))
                    };
                class d extends HTMLElement {
                    constructor() {
                        super(), this.onActiveFilterClick = this.onActiveFilterClick.bind(this), this.handleMobileSort = this.handleMobileSort.bind(this), this.handleSortForm = this.handleSortForm.bind(this), this.handleFilterForm = this.handleFilterForm.bind(this), this.debouncedOnSubmit = (0, n.Ds)((e => {
                            this.onSubmitHandler(e)
                        }), 500), this.querySelector("form").addEventListener("input", this.debouncedOnSubmit.bind(this)), this.setupMobileSort()
                    }
                    setupMobileSort() {
                        const e = document.querySelector("#SortByMobile");
                        e && (e.removeEventListener("change", this.handleMobileSort), e.addEventListener("change", this.handleMobileSort))
                    }
                    handleMobileSort(e) {
                        const t = document.querySelector("#FacetSortForm");
                        if (t) {
                            const i = t.querySelector("select");
                            i && (i.value = e.target.value, this.debouncedOnSubmit(e))
                        }
                    }
                    handleSortForm(e) {
                        const t = document.querySelector("#FacetFiltersForm");
                        let i = "";
                        if (t) {
                            const e = new FormData(t);
                            i = new URLSearchParams(e).toString()
                        }
                        const n = this.createSearchParams(e);
                        return i ? `${i}&${n}` : n
                    }
                    handleFilterForm() {
                        const e = [],
                            t = document.querySelectorAll("form.facet-form"),
                            i = ["FacetAvailabilityForm", "FacetSortForm", "FacetFiltersForm", "FacetSearchForm"];
                        t.forEach((t => {
                            if (i.includes(t.id)) {
                                const i = this.createSearchParams(t);
                                "" !== i && e.push(i)
                            }
                        }));
                        const n = e.join("&").split("&");
                        return [...new Set(n)].join("&")
                    }
                    onSubmitHandler(e) {
                        e.preventDefault();
                        const t = e.target.closest("form");
                        if (!t) return;
                        if ("FacetSortForm" === t.id) {
                            const i = this.handleSortForm(t);
                            return void this.onSubmitForm(i, e)
                        }
                        const i = this.handleFilterForm();
                        this.onSubmitForm(i, e)
                    }
                    static renderFilters(e, t) {
                        const i = (new DOMParser).parseFromString(e, "text/html"),
                            n = "#FacetFiltersForm .js-filter, #FacetAvailabilityForm .js-filter, #FacetSortForm .js-filter",
                            r = i.querySelectorAll(n),
                            s = document.querySelectorAll(n);
                        Array.from(s).forEach((e => {
                            Array.from(r).some((t => {
                                let {
                                    id: i
                                } = t;
                                return e.id === i
                            })) || e.remove()
                        }));
                        const o = e => {
                                const i = t ? t.target.closest(".js-filter") : void 0;
                                return !!i && e.id === i.id
                            },
                            a = Array.from(r).filter((e => !o(e)));
                        a.forEach(((e, t) => {
                            if (document.getElementById(e.id)) document.getElementById(e.id).innerHTML = e.innerHTML;
                            else {
                                if (t > 0) {
                                    const {
                                        className: i,
                                        id: n
                                    } = a[t - 1];
                                    if (e.className === i) return void document.getElementById(n).after(e)
                                }
                                if (e.parentElement) {
                                    const t = document.querySelector(`#${e.parentElement.id} .js-filter`);
                                    t ? t.before(e) : e.parentElement.appendChild(e)
                                }
                            }
                        }));
                        const c = document.querySelector("facet-filters-form");
                        c && c.setupMobileSort();
                        const l = Array.from(r).find(o);
                        l && t.target.closest(".js-filter").id && d.renderCounts(l, t.target.closest(".js-filter")), d.renderAdditionalElements(i)
                    }
                    static setListeners() {
                        window.addEventListener("popstate", (e => {
                            const t = e.state ? e.state.searchParams : d.searchParamsInitial;
                            t !== d.searchParamsPrev && d.renderPage(t, null, !1)
                        }))
                    }
                    static renderPage(e, t) {
                        let i = !(arguments.length > 2 && void 0 !== arguments[2]) || arguments[2];
                        d.searchParamsPrev = e;
                        const n = d.getSections();
                        document.getElementById("ProductGridContainer").classList.add("loading"), n.forEach((i => {
                            const n = `${window.location.pathname}?section_id=${i.section}&${e}`,
                                r = e => e.url === n;
                            d.filterData.some(r) ? d.renderSectionFromCache(r, t) : d.renderSectionFromFetch(n, t)
                        })), i && d.updateURLHash(e)
                    }
                    static renderSectionFromFetch(e, t) {
                        fetch(e).then((e => e.text())).then((i => {
                            const r = i;
                            d.filterData = [...d.filterData, {
                                html: r,
                                url: e
                            }], d.renderFilters(r, t), d.renderProductGridContainer(r), document.getElementById("ProductGridContainer").classList.remove("loading"), (0, n.X5)(document.querySelector("div.grid-archive__outer-container"), document.getElementById("grid-archive-header").offsetHeight)
                        }))
                    }
                    static renderSectionFromCache(e, t) {
                        const i = d.filterData.find(e).html;
                        d.renderFilters(i, t), d.renderProductGridContainer(i), document.getElementById("ProductGridContainer").classList.remove("loading")
                    }
                    static renderProductGridContainer(e) {
                        document.getElementById("ProductGridContainer").innerHTML = (new DOMParser).parseFromString(e, "text/html").getElementById("ProductGridContainer").innerHTML, l(), document.getElementById("ProductGridContainer").querySelectorAll(".icon").forEach((e => {
                            e.classList.add("loaded")
                        })), (0, n.Sw)(), (0, r.f)(), (0, a.M)(), new o.M
                    }
                    static renderAdditionalElements(e) {
                        this.updateElementFromHTML(".facets__active", e), this.updateElementFromHTML(".facets__clear", e), document.querySelectorAll("facet-filters-form .icon").forEach((e => {
                            e.classList.add("loaded")
                        }))
                    }
                    static updateElementFromHTML(e, t) {
                        const i = t.querySelector(e);
                        i && (document.querySelector(e).innerHTML = i.innerHTML)
                    }
                    static renderCounts(e, t) {
                        const i = t.querySelector("summary"),
                            n = e.querySelector("summary");
                        n && i && (i.outerHTML = n.outerHTML)
                    }
                    static updateURLHash(e) {
                        history.pushState({
                            searchParams: e
                        }, "", `${window.location.pathname}${e&&"?".concat(e)}`)
                    }
                    static getSections() {
                        return [{
                            section: document.getElementById("grid-product").dataset.id
                        }]
                    }
                    createSearchParams(e) {
                        const t = new FormData(e);
                        return new URLSearchParams(t).toString()
                    }
                    onSubmitForm(e, t) {
                        d.renderPage(e, t)
                    }
                    onActiveFilterClick(e) {
                        e.preventDefault();
                        const t = new URL(e.currentTarget.href).search.substring(1);
                        d.renderPage(t)
                    }
                }
                d.filterData = [], d.searchParamsInitial = window.location.search.slice(1), d.searchParamsPrev = window.location.search.slice(1), d.setListeners(), customElements.get("facet-filters-form") || customElements.define("facet-filters-form", d);
                class u extends HTMLElement {
                    constructor() {
                        super(), this.querySelector("a").addEventListener("click", (e => {
                            e.preventDefault(), (this.closest("facet-filters-form#facets") || document.querySelector("facet-filters-form#facets")).onActiveFilterClick(e)
                        }))
                    }
                }
                customElements.get("facet-remove") || customElements.define("facet-remove", u);
                class h extends HTMLElement {
                    constructor() {
                        super(), this.desktopMedia = window.matchMedia("(min-width: 1024px)")
                    }
                    connectedCallback() {
                        l(), this.toggleSidebar(), (0, n.Sw)()
                    }
                    toggleSidebar = () => {
                        const e = window.matchMedia("(max-width: 1024px)");
                        document.querySelectorAll(".grid-archive").forEach((t => {
                            const i = t.closest(".shopify-section").querySelector(".toggle-filtering"),
                                r = t.querySelector(".grid-archive__filters-container"),
                                s = () => {
                                    t.classList.remove("grid-archive__main-container--filters-shown"), (0, n.gp)(!1, s)
                                },
                                o = () => {
                                    t.classList.remove("grid-archive__main-container-mobile--filters-shown"), (0, n.g)(!1, "laptop-down"), c.close(), (0, n.gp)(!1, o)
                                },
                                a = e => {
                                    e.target.closest(".facets") || (o(), r.removeEventListener("click", a))
                                };
                            i && i.addEventListener("click", (() => {
                                e.matches ? (t.classList.add("grid-archive__main-container-mobile--filters-shown"), (0, n.g)(!0, "laptop-down"), c.open({
                                    attachElements: [r]
                                }), (0, n.gp)(!0, o), r.addEventListener("click", a)) : t.classList.contains("grid-archive__main-container--filters-shown") ? s() : (t.classList.add("grid-archive__main-container--filters-shown"), (0, n.gp)(!0, s))
                            })), r && r.querySelector(".facets__mobile-close").addEventListener("click", (e => {
                                e.preventDefault(), o()
                            })), e.addEventListener("change", (() => {
                                t.classList.contains("grid-archive__main-container-mobile--filters-shown") && o()
                            }))
                        }))
                    };
                    syncSorts = () => {
                        if (0 == document.querySelectorAll("#SortByMobile").length) return;
                        const e = document.querySelectorAll("#SortBy, #SortByMobile");
                        e.forEach((t => {
                            t.addEventListener("change", (function(t) {
                                e.forEach((e => {
                                    e.value = t.target.value
                                }));
                                const i = new Event("input");
                                document.querySelector("#FacetSortForm").dispatchEvent(i)
                            }))
                        }))
                    }
                }
                customElements.get("filters-component") || customElements.define("filters-component", h)
            },
            4056: function() {
                class e extends HTMLElement {
                    constructor() {
                        super(), this.fromSlider = this.querySelectorAll("input[type='range']")[0], this.toSlider = this.querySelectorAll("input[type='range']")[1], this.fromInput = this.querySelectorAll("input[type='number']")[0], this.toInput = this.querySelectorAll("input[type='number']")[1], this.resetButton = this.querySelector("input[type='button'].range--reset"), this.mobileLabelFrom = this.querySelector(".range--slider-label-from-value"), this.mobileLabelTo = this.querySelector(".range--slider-label-to-value"), this.rangeMin = this.toInput.min, this.rangeMax = this.toInput.max, this.rangeDistance = this.rangeMax - this.rangeMin, this.sliderColor = this.dataset.sliderColor || "#b1b1b1", this.rangeColor = this.dataset.rangeColor || "#989898", this.setSlider(this.fromSlider.value, this.toSlider.value)
                    }
                    addListeners() {
                        this.fromSlider.addEventListener("input", this.updateFromSlider.bind(this)), this.toSlider.addEventListener("input", this.updateToSlider.bind(this)), this.fromInput.addEventListener("input", this.updateFromInput.bind(this)), this.fromInput.addEventListener("keypress", this.validateNumberInput), this.toInput.addEventListener("input", this.updateToInput.bind(this)), this.toInput.addEventListener("keypress", this.validateNumberInput), this.resetButton.addEventListener("click", this.handleResetButtonClick.bind(this))
                    }
                    validateNumberInput(e) {
                        8 === e.charCode || e.charCode >= 48 && e.charCode <= 57 || e.preventDefault()
                    }
                    connectedCallback() {
                        this.addListeners()
                    }
                    updateFromInput(e) {
                        const [t, i] = this.getParsed(this.fromInput, this.toInput), n = null !== t ? t : Number(this.fromInput.min), r = i || Number(this.toInput.max);
                        n < this.fromInput.min ? this.fromInput.value = Number(this.fromInput.min) : n > r && (this.fromInput.value = r), this.fromInput.value ? this.fromInput.value <= r ? (this.setSlider(this.fromInput.value, !1), this.mobileLabelFrom.innerHTML = this.fromInput.value, this.showResetButton()) : e.stopPropagation() : (this.setSlider(n, !1), this.mobileLabelFrom.innerHTML = n)
                    }
                    updateToInput(e) {
                        const [t, i] = this.getParsed(this.fromInput, this.toInput), n = null !== i ? i : Number(this.toInput.max), r = t || Number(this.fromInput.min);
                        n > this.toInput.max && (this.toInput.value = Number(this.toInput.max)), this.toInput.value ? r <= this.toInput.value ? (this.setSlider(!1, this.toInput.value), this.mobileLabelTo.innerHTML = this.toInput.value, this.showResetButton()) : e.stopPropagation() : (this.setSlider(!1, n), this.mobileLabelTo.innerHTML = n)
                    }
                    updateFromSlider() {
                        const [e, t] = this.getParsed(this.fromSlider, this.toSlider);
                        e > t ? (this.fromSlider.value = t, this.fromInput.value = t) : this.fromInput.value = e, this.fromInput.dispatchEvent(new Event("input", {
                            bubbles: !0
                        }))
                    }
                    updateToSlider() {
                        const [e, t] = this.getParsed(this.fromSlider, this.toSlider);
                        e <= t ? this.toInput.value = t : (this.toInput.value = e, this.toSlider.value = e), this.toInput.dispatchEvent(new Event("input", {
                            bubbles: !0
                        }))
                    }
                    getParsed(e, t) {
                        return [e.value ? parseInt(e.value, 10) : null, t.value ? parseInt(t.value, 10) : null]
                    }
                    setSlider(e, t) {
                        !1 !== e && (this.fromSlider.value = e), !1 !== t && (this.toSlider.value = t);
                        const i = this.fromSlider.value - this.rangeMin,
                            n = this.toSlider.value - this.rangeMin,
                            r = i / this.rangeDistance * 100,
                            s = n / this.rangeDistance * 100,
                            o = 8 - .15 * r,
                            a = 8 - .15 * s;
                        this.fillSlider(r, s, o, a)
                    }
                    fillSlider(e, t, i, n) {
                        this.toSlider.style.background = `linear-gradient(\n      to right,\n      ${this.sliderColor} 0%,\n      ${this.sliderColor} calc(${e}% + ${i}px),\n      ${this.rangeColor} calc(${e}% + ${i}px),\n      ${this.rangeColor} calc(${t}% + ${n}px),\n      ${this.sliderColor} calc(${t}% + ${n}px),\n      ${this.sliderColor} 100%)`
                    }
                    handleResetButtonClick(e) {
                        e.preventDefault(), e.stopPropagation(), this.fromInput.value = null, this.toInput.value = null, this.fromInput.dispatchEvent(new Event("input", {
                            bubbles: !0
                        })), this.toInput.dispatchEvent(new Event("input", {
                            bubbles: !0
                        })), this.hideResetButton()
                    }
                    removeListeners() {
                        this.fromSlider.removeEventListener("input", this.updateFromSlider.bind(this)), this.toSlider.removeEventListener("input", this.updateToSlider.bind(this)), this.fromInput.removeEventListener("input", this.updateFromInput.bind(this)), this.toInput.removeEventListener("input", this.updateToInput.bind(this)), this.resetButton.removeEventListener("click", this.handleResetButtonClick.bind(this))
                    }
                    hideResetButton() {
                        this.resetButton.classList.add("hidden")
                    }
                    showResetButton() {
                        this.resetButton.classList.remove("hidden")
                    }
                    disconnectedCallback() {
                        this.removeListeners()
                    }
                }
                customElements.get("price-range") || customElements.define("price-range", e)
            },
            4487: function(e, t, i) {
                "use strict";
                var n = i(6072);
                const r = new class {
                    constructor() {
                        this.items = Array.from(document.querySelectorAll(".cart-item")), this.items.forEach((e => this.manageState(e))), this.selectorsToUpdate = [".cart-summary__header", "#cart-total-price", "#checkout", ".cart-summary__free-shipping"], this.mainCartSelector = ".shopify-section.cart", this.miniCart = document.getElementById("mini-cart"), this.itemsContainersSelector = ".cart-items-container, .cart__empty, .mini-cart--empty", this.parser = new DOMParser
                    }
                    manageState(e) {
                        const t = e.getAttribute("data-variant-id");
                        e.querySelector(".cart-item-delete, .cart-item__remove").addEventListener("click", (async () => {
                            await this.changeCartItem({
                                id: t,
                                quantity: 0
                            }), e.remove()
                        }));
                        const i = e.querySelector('input[name="quantity"]');
                        if (!i) return;
                        const n = e.querySelector('button[name="plus"]'),
                            r = e.querySelector('button[name="minus"]'),
                            s = e.querySelector('input[name="quantity"]');
                        let o = parseInt(i.value);
                        n.addEventListener("click", (() => {
                            o += 1, i.value = o, this.changeCartItem({
                                id: t,
                                quantity: o
                            })
                        })), r.addEventListener("click", (() => {
                            o -= 1, i.value = o, this.changeCartItem({
                                id: t,
                                quantity: o
                            })
                        })), s.addEventListener("change", (e => {
                            parseInt(e.target.value) > 0 ? (o = parseInt(e.target.value), this.changeCartItem({
                                id: t,
                                quantity: o
                            })) : s.value = o
                        })), s.addEventListener("keypress", (e => {
                            (8 !== e.which && 0 !== e.which && e.which < 48 || e.which > 57) && e.preventDefault()
                        }))
                    }
                    async changeCartItem(e) {
                        const t = {
                            ...(0, n.Q2)(),
                            body: JSON.stringify({
                                line: +e.id,
                                quantity: e.quantity,
                                sections: "main-cart"
                            })
                        };
                        fetch(`${routes.cartChange}`, t).then((e => e.json())).then((e => {
                            const t = t => {
                                const i = this.parser.parseFromString(t, "text/html");
                                if (0 === e.item_count) {
                                    const e = document.querySelector(this.mainCartSelector);
                                    e && (e.innerHTML = i.querySelector(this.mainCartSelector).innerHTML), this.renderElements(i)
                                } else this.renderItems(i)
                            };
                            if (e.sections && null !== e.sections["main-cart"]) t(e.sections["main-cart"]);
                            else {
                                const e = `${window.location.pathname}?section_id=main-cart`;
                                fetch(e).then((e => e.text())).then((e => {
                                    t(e)
                                }))
                            }
                            const i = `${window.location.pathname}?section_id=navigation-main`;
                            fetch(i).then((e => e.text())).then((t => {
                                const i = this.parser.parseFromString(t, "text/html");
                                if (0 === e.item_count) {
                                    const e = document.querySelector("#mini-cart");
                                    e && (e.innerHTML = i.querySelector("#mini-cart").innerHTML, e.addEventListeners(), e.querySelectorAll(".icon").forEach((e => e.classList.add("loaded"))))
                                }
                            }))
                        })).catch((e => {
                            console.error(e)
                        }))
                    }
                    renderElements(e) {
                        this.selectorsToUpdate.forEach((t => {
                            try {
                                const i = document.querySelectorAll(t),
                                    n = e.querySelector(t);
                                i.length && n && i.forEach((e => {
                                    n.querySelectorAll(".icon").forEach((e => e.classList.add("loaded"))), e.replaceWith(n.cloneNode(!0))
                                }))
                            } catch (e) {
                                console.error(`Error updating ${t}`, e)
                            }
                        }));
                        const t = e.querySelector(".cart-count");
                        document.querySelectorAll("#cart-open-block .header__icons--cart-open .cart-count").forEach((e => {
                            t ? (e.classList.contains("visually-hidden") && e.classList.remove("visually-hidden"), e.textContent = t.textContent) : e.classList.add("visually-hidden")
                        })), document.querySelector("#cart-open-block .icon").classList.add("loaded")
                    }
                    renderItems(e) {
                        this.renderElements(e);
                        const t = Array.from(document.querySelectorAll(this.itemsContainersSelector)),
                            i = e.querySelector(this.itemsContainersSelector);
                        t.forEach((e => {
                            e && e.replaceWith(i.cloneNode(!0))
                        })), document.querySelectorAll(".cart-item").forEach((e => {
                            e.querySelectorAll(".icon").forEach((e => e.classList.add("loaded"))), this.manageState(e)
                        }))
                    }
                    updateMiniCart(e) {
                        return fetch("/?section_id=main-cart").then((e => e.text())).then((t => {
                            this.renderItems((new DOMParser).parseFromString(t, "text/html")), e && "mini-cart" === cartStrings.uxCart && this.miniCart && this.miniCart.open()
                        })).catch((e => {
                            console.error("Error updating mini cart:", e)
                        }))
                    }
                };
                t.Z = r, customElements.get("cart-note") || customElements.define("cart-note", class extends HTMLElement {
                    constructor() {
                        super(), this.querySelector("textarea").addEventListener("change", (0, n.Ds)((e => {
                            const t = JSON.stringify({
                                note: e.target.value
                            });
                            fetch(`${routes.cartUpdate}`, {
                                ...(0, n.Q2)(),
                                body: t
                            })
                        }), 300))
                    }
                })
            },
            1717: function(e, t, i) {
                "use strict";
                i.d(t, {
                    f: function() {
                        return s
                    }
                });
                var n = i(6072),
                    r = i(4487);
                const s = () => {
                    const e = document.querySelectorAll('form[data-type="add-to-cart-form"]'),
                        t = document.getElementById("main-cart"),
                        i = document.getElementById("mini-cart"),
                        s = document.querySelector("body");
                    e.length && e.forEach((e => e.addEventListener("submit", (o => {
                        if (o.target.dataset.sub) return;
                        o.target.dataset.sub = 1;
                        setTimeout(() => o.target.dataset.sub = '', 100);
                        o.preventDefault(), o.stopPropagation(), o.target.querySelector('button[type="submit"] > span:not(.cart-icon):not(:empty)') && (o.target.querySelector('button[type="submit"] > span:not(.cart-icon):not(:empty)').textContent = `${cartStrings.addingToCart}`);
                        const a = o.target.querySelector('button[type="submit"]'),
                            c = a.querySelector("span.cart-icon"),
                            l = a.querySelector("svg.loading-icon");
                        s.classList.remove("added-to-cart"), a.classList.add("added"), c.style.display = "none", l.style.display = "block";
                        const d = (0, n.Q2)("javascript");
                        d.headers["X-Requested-With"] = "XMLHttpRequest", delete d.headers["Content-Type"];
                        const u = new FormData(e);
                        u.append("sections", "main-cart"), d.body = u, fetch(`${routes.cartAdd}`, d).then((e => e.json())).then((async e => {
                            if (e.status) {
                                if (r.Z.updateMiniCart(!0), c.style.display = "inline-flex", l.style.display = "none", o.target.querySelector('button[type="submit"] > span:not(.cart-icon):not(:empty)') && (o.target.querySelector('button[type="submit"] > span:not(.cart-icon):not(:empty)').textContent = `${cartStrings.addToCart}`), "object" == typeof e.description) return Object.entries(e.description).forEach((e => {
                                    let [t, i] = e;
                                    const n = `${i.join(", ")}`;
                                    o.target.querySelector(".main-product__error").innerHTML = '<span class="icon loaded">error</span><p>' + n + "</p>"
                                }));
                                o.target.querySelector(".main-product__error").innerHTML = '<span class="icon loaded">error</span><p>' + e.description + "</p>"
                            } else {
                                if ("cart" === cartStrings.uxCart) return void(window.location.href = window.routes.cart);
                                if (o.target.querySelector(".main-product__error").innerHTML = "", t && t.classList.add("added"), e.sections && null !== e.sections["main-cart"]) r.Z.renderItems((new DOMParser).parseFromString(e.sections["main-cart"], "text/html"));
                                else {
                                    const e = `${window.location.pathname}?section_id=main-cart`;
                                    fetch(e).then((e => e.text())).then((e => {
                                        r.Z.renderItems((new DOMParser).parseFromString(e, "text/html"))
                                    }))
                                }
                                "mini-cart" === cartStrings.uxCart && i && i.open(), o.target.querySelector('button[type="submit"] > span:not(.cart-icon):not(:empty)') && (o.target.querySelector('button[type="submit"] > span:not(.cart-icon):not(:empty)').textContent = `${cartStrings.addedToCart}`), a.classList.remove("added"), a.classList.add("successful"), c.style.display = "flex", l.style.display = "none", s.classList.add("added-to-cart")
                            }
                        })).catch((e => {
                            console.error("Error:", e)
                        }))
                    }))))
                }
            },
            1434: function(e, t) {
                "use strict";
                const i = "above-overlay",
                    n = new Set;
                t.Z = class {
                    isClosingTimer = null;
                    attachedElements = new Set;
                    constructor() {
                        let e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : document.querySelector("#main-content");
                        this.container = e, this.overlay = document.createElement("div"), this.overlay.innerHTML = "&nbsp;", this.overlay.classList.add("overlay"), this.overlay.addEventListener("transitionend", (e => {
                            "opacity" !== e.propertyName || this.isOpen || (this.attachedElements && this.attachedElements.size && this.attachedElements.forEach((e => {
                                this.detachElement(e)
                            })), this.afterClosed && (this.afterClosed(), this.afterClosed = null), this.detachOverlay()), "opacity" === e.propertyName && this.isOpen && this.afterOpened && (this.afterOpened(), this.afterOpened = null)
                        })), n.add(this)
                    }
                    attachOverlay() {
                        this.container.appendChild(this.overlay)
                    }
                    detachOverlay() {
                        this.container.removeChild(this.overlay)
                    }
                    async open() {
                        let {
                            attachElements: e,
                            afterOpened: t,
                            beforeOpened: n
                        } = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
                        await this.attachOverlay(), this.isClosingTimer && (clearTimeout(this.isClosingTimer), this.isClosingTimer = null), n && n(), e && (e.forEach((e => {
                            this.attachedElements.add(e)
                        })), this.attachedElements.forEach((e => {
                            e.classList.add(i)
                        }))), requestAnimationFrame((() => {
                            this.overlay.classList.add("open")
                        })), t && (this.afterOpened = t)
                    }
                    close() {
                        let {
                            delay: e,
                            beforeClosed: t,
                            afterClosed: i
                        } = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
                        t && t(), this.afterClosed = i;
                        const n = () => {
                            requestAnimationFrame((() => {
                                this.overlay.classList.remove("open")
                            }))
                        };
                        e ? this.isClosingTimer = setTimeout(n, e) : n()
                    }
                    detachElement(e) {
                        this.attachedElements.has(e) && e.classList.contains(i) && (e.classList.remove(i), this.attachedElements.delete(e))
                    }
                    get isOpen() {
                        return this.overlay.classList.contains("open")
                    }
                    onClick() {
                        let e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : () => {};
                        e && this.overlay.addEventListener("click", e)
                    }
                    removeOnClick() {
                        let e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : () => {};
                        e && this.overlay.removeEventListener("click", e)
                    }
                    onHover() {
                        let e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : () => {};
                        e && this.overlay.addEventListener("mouseover", (t => {
                            this.isOpen && e(t)
                        }))
                    }
                }
            },
            3643: function(e, t, i) {
                "use strict";
                i.d(t, {
                    M: function() {
                        return n
                    }
                }), (0, i(8464).z2)();
                class n {
                    constructor() {
                        this.initializeSwipers(), Shopify.designMode && document.addEventListener("shopify:section:load", (() => this.initializeSwipers()))
                    }
                    initializeSwipers() {
                        document.querySelectorAll("swiper-container").forEach((e => {
                            e.dataset.mobileSlidesPerView;
                            const t = (e.dataset.desktopSlidesPerView, "0" !== e.dataset.tabletSlidesPerView && e.dataset.tabletSlidesPerView && e.dataset.tabletSlidesPerView, "true" === e.dataset.textPagination),
                                i = Number(e.dataset.spaceBetweenMobile) || 16,
                                n = Number(e.dataset.spaceBetweenTablet) || 32,
                                r = Number(e.dataset.spaceBetweenDesktop) || 32,
                                s = e.dataset.mobileLayout || "slider",
                                o = e.dataset.desktopLayout || "slider",
                                a = window.matchMedia("(min-width: 0px) and (max-width: 1023px)"),
                                c = window.matchMedia("(min-width: 1024px)"),
                                l = () => {
                                    e.querySelectorAll("video").forEach((e => {
                                        e.classList.contains("section__wrapper-background") || e.pause()
                                    })), Array.from(e.querySelectorAll("swiper-slide")).filter((e => e.classList.contains("swiper-slide-visible"))).forEach((e => {
                                        const t = e.querySelector("video");
                                        t && t.hasAttribute("autoplay") && t.play()
                                    }))
                                },
                                d = () => {
                                    const t = e.closest(".slideshow-text-controls__wrapper");
                                    if (!t) return;
                                    const i = e.swiper.slides[e.swiper.realIndex];
                                    if (!i) return;
                                    const n = i.getAttribute("data-slide");
                                    t.querySelectorAll(".slideshow-text-controls__item").forEach((e => {
                                        e.classList.toggle("active", e.getAttribute("data-slide") === n)
                                    }))
                                },
                                u = () => {
                                    if (c.matches && "slider" === o || a.matches && "slider" === s)
                                        if (!e.swiper || e.swiper.destroyed) {
                                            var u;
                                            const s = parseFloat(e.dataset.mobileSlidesPerView) || "auto",
                                                o = "0" !== e.dataset.tabletSlidesPerView && e.dataset.tabletSlidesPerView ? parseFloat(e.dataset.tabletSlidesPerView) : s,
                                                a = parseFloat(e.dataset.desktopSlidesPerView) || "auto",
                                                c = {
                                                    ...null !== (u = e.parentElement) && void 0 !== u && u.classList.contains("card__image") ? {
                                                        virtual: {
                                                            enabled: !0
                                                        },
                                                        nested: !0
                                                    } : {},
                                                    breakpoints: {
                                                        0: {
                                                            slidesPerView: s,
                                                            spaceBetween: parseInt(i)
                                                        },
                                                        768: {
                                                            slidesPerView: o,
                                                            spaceBetween: parseInt(n)
                                                        },
                                                        1024: {
                                                            slidesPerView: a,
                                                            spaceBetween: parseInt(r)
                                                        }
                                                    }
                                                };
                                            Object.assign(e, c), e.addEventListener("swiperafterinit", (() => {
                                                const t = e.closest(".shopify-section");
                                                t && t.classList.add("slider-enabled"), setTimeout((() => {
                                                    var t, i;
                                                    if (!e.swiper) return;
                                                    const n = (null === (t = e.swiper) || void 0 === t || null === (i = t.slides) || void 0 === i ? void 0 : i.length) || 0,
                                                        r = n < s ? n : s,
                                                        c = n < o ? n : o,
                                                        d = n < a ? n : a;
                                                    e.swiper && e.swiper.params && e.swiper.params.breakpoints && (e.swiper.currentBreakpoint = !1, e.swiper.params.breakpoints[0].slidesPerView = r, e.swiper.params.breakpoints[768].slidesPerView = c, e.swiper.params.breakpoints[992].slidesPerView = d, e.swiper.update(), e.swiper.slideTo(0, 0, !1)), l(), (() => {
                                                        var t;
                                                        const i = null === (t = e.closest(".main-product__media-wrapper")) || void 0 === t ? void 0 : t.querySelector(".swiper-thumbnails .swiper");
                                                        i && (Object.assign(i, {
                                                            direction: "vertical",
                                                            slidesPerView: "auto",
                                                            spaceBetween: 8,
                                                            watchSlidesProgress: !0,
                                                            navigation: {
                                                                nextEl: ".swiper-button-thumbs-next",
                                                                prevEl: ".swiper-button-thumbs-prev"
                                                            },
                                                            breakpoints: {
                                                                0: {
                                                                    direction: "horizontal",
                                                                    slidesPerView: 4
                                                                },
                                                                768: {
                                                                    direction: "vertical",
                                                                    slidesPerView: "auto"
                                                                }
                                                            }
                                                        }), i.initialize())
                                                    })()
                                                }), 0)
                                            })), e.addEventListener("swiperslidechange", (() => {
                                                l(), d()
                                            })), e.addEventListener("swiperdestroy", (() => {
                                                const t = e.closest(".shopify-section");
                                                t && t.classList.remove("slider-enabled")
                                            })), e.addEventListener("swiperlock", (() => {
                                                const t = e.closest(".shopify-section");
                                                t && !t.classList.contains("recommended-products") && setTimeout((() => {
                                                    t.querySelectorAll(".grid-content__slider-nav").forEach((e => {
                                                        e.style.display = "none"
                                                    }))
                                                }), 1)
                                            })), e.initialize(), t && ((() => {
                                                if (!t) return;
                                                const i = e.closest(".slideshow-text-controls__wrapper");
                                                i && i.querySelectorAll(".slideshow-text-controls__item").forEach((t => {
                                                    t.addEventListener("click", (() => {
                                                        const i = t.getAttribute("data-slide"),
                                                            n = Array.from(e.swiper.slides).findIndex((e => e.getAttribute("data-slide") === i)); - 1 !== n && e.swiper.slideTo(n)
                                                    }))
                                                }))
                                            })(), d())
                                        } else e.swiper.update();
                                    else if (Object.assign(e), e.initialize(), e.swiper) {
                                        e.swiper.destroy(!0, !0);
                                        const t = e.closest(".shopify-section");
                                        t && t.classList.remove("slider-enabled")
                                    }
                                };
                            window.addEventListener("resize", u), u()
                        }))
                    }
                }
                new n
            },
            6072: function(e, t, i) {
                "use strict";
                i.d(t, {
                    Ds: function() {
                        return l
                    },
                    Q2: function() {
                        return n
                    },
                    Sw: function() {
                        return m
                    },
                    X5: function() {
                        return d
                    },
                    g: function() {
                        return s
                    },
                    gp: function() {
                        return c
                    },
                    hO: function() {
                        return r
                    },
                    zx: function() {
                        return h
                    }
                });
                const n = function() {
                        return {
                            method: "POST",
                            headers: {
                                "Content-Type": "application/json",
                                Accept: `application/${arguments.length>0&&void 0!==arguments[0]?arguments[0]:"json"}`
                            }
                        }
                    },
                    r = function() {
                        let e = arguments.length > 0 && void 0 !== arguments[0] && arguments[0];
                        const t = window.innerWidth - document.body.offsetWidth,
                            i = document.getElementById("nav-wrapper");
                        e ? (document.body.classList.add("no-scroll"), document.body.style.paddingRight = t + "px", i.style.paddingRight = t + "px") : (document.body.classList.remove("no-scroll"), document.body.style.paddingRight = "0px", i.style.paddingRight = "0px")
                    },
                    s = function() {
                        let e = arguments.length > 1 ? arguments[1] : void 0;
                        arguments.length > 0 && void 0 !== arguments[0] && arguments[0] ? document.body.classList.add(`no-scroll--${e}`) : document.body.classList.remove(`no-scroll--${e}`)
                    };
                let o = () => {};
                const a = e => {
                        "Escape" === e.key && (o(), window.removeEventListener("keydown", a))
                    },
                    c = function() {
                        let e = arguments.length > 0 && void 0 !== arguments[0] && arguments[0],
                            t = arguments.length > 1 ? arguments[1] : void 0;
                        t && (o = t), e && window.addEventListener("keydown", a), e || window.removeEventListener("keydown", a)
                    };

                function l(e, t) {
                    const i = this;
                    let n;
                    return function() {
                        for (var r = arguments.length, s = new Array(r), o = 0; o < r; o++) s[o] = arguments[o];
                        clearTimeout(n), n = setTimeout((function() {
                            return e.apply(i, s)
                        }), t)
                    }
                }

                function d(e) {
                    let t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 0;
                    const i = document.getElementById("nav-wrapper"),
                        n = document.querySelector(".header").getAttribute("data-ux-position"),
                        r = e.getBoundingClientRect().top;
                    window.scrollTo({
                        top: "off" !== n ? r + window.scrollY - t + parseFloat(i.style.marginTop) : r + window.scrollY - t,
                        behavior: "smooth"
                    })
                }
                document.querySelectorAll(".local-scroll").forEach((e => {
                    e.addEventListener("click", (e => {
                        e.preventDefault(), e.stopPropagation();
                        const t = e.target.getAttribute("href");
                        d(document.querySelector(t))
                    }))
                }));
                const u = {};

                function h(e) {
                    document.removeEventListener("focusin", u.focusin), document.removeEventListener("focusout", u.focusout), document.removeEventListener("keydown", u.keydown), e && e.focus()
                }
                const m = () => {
                    const e = document.querySelector(".grid-archive__content");
                    document.querySelector(".grid-archive__subnav .cols") && (document.querySelectorAll(".view-icon-desktop").forEach((t => {
                        t.onclick = function() {
                            document.querySelectorAll(".view-icon-desktop").forEach((e => {
                                e.classList.remove("active")
                            })), this.classList.add("active"), localStorage.setItem("columns-desktop", t.dataset.columns), 4 == t.dataset.columns ? (e.classList.remove("grid-archive__content--three-column"), e.classList.add("grid-archive__content--four-column")) : (e.classList.add("grid-archive__content--three-column"), e.classList.remove("grid-archive__content--four-column"))
                        }
                    })), document.querySelectorAll(".view-icon-mobile").forEach((t => {
                        t.onclick = function() {
                            document.querySelectorAll(".view-icon-mobile").forEach((e => {
                                e.classList.remove("active")
                            })), this.classList.add("active"), localStorage.setItem("columns-mobile", t.dataset.columns), 1 == t.dataset.columns ? (e.classList.remove("grid-archive__content--two-column"), e.classList.add("grid-archive__content--one-column")) : (e.classList.add("grid-archive__content--two-column"), e.classList.remove("grid-archive__content--one-column"))
                        }
                    })), 4 == localStorage.getItem("columns-desktop") && (e.classList.remove("grid-archive__content--three-column"), e.classList.add("grid-archive__content--four-column"), document.querySelector(".three-col").classList.remove("active"), document.querySelector(".four-col").classList.add("active")), 1 == localStorage.getItem("columns-mobile") && (e.classList.remove("grid-archive__content--two-column"), e.classList.add("grid-archive__content--one-column"), document.querySelector(".two-col").classList.remove("active"), document.querySelector(".one-col").classList.add("active")))
                }
            },
            5122: function() {}
        },
        i = {};

    function n(e) {
        var r = i[e];
        if (void 0 !== r) return r.exports;
        var s = i[e] = {
            exports: {}
        };
        return t[e](s, s.exports, n), s.exports
    }
    n.m = t, e = [], n.O = function(t, i, r, s) {
            if (!i) {
                var o = 1 / 0;
                for (d = 0; d < e.length; d++) {
                    i = e[d][0], r = e[d][1], s = e[d][2];
                    for (var a = !0, c = 0; c < i.length; c++)(!1 & s || o >= s) && Object.keys(n.O).every((function(e) {
                        return n.O[e](i[c])
                    })) ? i.splice(c--, 1) : (a = !1, s < o && (o = s));
                    if (a) {
                        e.splice(d--, 1);
                        var l = r();
                        void 0 !== l && (t = l)
                    }
                }
                return t
            }
            s = s || 0;
            for (var d = e.length; d > 0 && e[d - 1][2] > s; d--) e[d] = e[d - 1];
            e[d] = [i, r, s]
        }, n.n = function(e) {
            var t = e && e.__esModule ? function() {
                return e.default
            } : function() {
                return e
            };
            return n.d(t, {
                a: t
            }), t
        }, n.d = function(e, t) {
            for (var i in t) n.o(t, i) && !n.o(e, i) && Object.defineProperty(e, i, {
                enumerable: !0,
                get: t[i]
            })
        }, n.o = function(e, t) {
            return Object.prototype.hasOwnProperty.call(e, t)
        }, n.j = 6955,
        function() {
            var e = {
                6955: 0,
                7658: 0,
                7954: 0,
                8973: 0,
                9217: 0,
                3625: 0,
                7317: 0
            };
            n.O.j = function(t) {
                return 0 === e[t]
            };
            var t = function(t, i) {
                    var r, s, o = i[0],
                        a = i[1],
                        c = i[2],
                        l = 0;
                    if (o.some((function(t) {
                            return 0 !== e[t]
                        }))) {
                        for (r in a) n.o(a, r) && (n.m[r] = a[r]);
                        if (c) var d = c(n)
                    }
                    for (t && t(i); l < o.length; l++) s = o[l], n.o(e, s) && e[s] && e[s][0](), e[s] = 0;
                    return n.O(d)
                },
                i = self.webpackChunkworkflow = self.webpackChunkworkflow || [];
            i.forEach(t.bind(null, 0)), i.push = t.bind(null, i.push.bind(i))
        }(), n.O(void 0, [1216], (function() {
            return n(5122)
        }));
    var r = n.O(void 0, [1216], (function() {
        return n(157)
    }));
    r = n.O(r)
}();